<template>
  <div class="mainCommonListContainer">
    <div class="buttonContainer">
      <div class="addDiv">
        <el-button @click="add()" v-if="null !== addPermission" class="addBtn"
          >{{ addPermission.name }}<i class="el-icon-plus el-icon--right"></i
        ></el-button>
      </div>
      <div id="queryDiv">
        <el-form :model="queryForm" @submit.native.prevent>
          <el-form-item label="">
            <el-input
              v-model="queryForm.areaname"
              placeholder="搜索区域名称"
              @keyup.enter.native="handleCurrentChange(1)"
              ><i
                class="el-icon-search"
                slot="suffix"
                @click="handleCurrentChange(1)"
              >
              </i
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="mainTableContainer">
      <el-table
        class="table"
        :data="tableData"
        height="491"
        style="width: 100%"
        ref="commonTable"
      >
        <!-- <el-table-column
          prop="area_id"
          label="序号"
          min-width="40"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column> -->
        <el-table-column
          prop="area_name"
          label="区域名称"
          min-width="70"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="updatetime"
          label="更新时间"
          min-width="40"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="操作"
          min-width="80"
          align="center"
          v-if="buttonList.length !== 0"
        >
          <template slot-scope="scope">
            <div class="buttonCol">
              <div
                v-for="(button, index) in buttonList"
                :key="index"
                class="buttonClass"
              >
                <el-button
                  v-if="button.path === 'areaList-edit'"
                  @click="edit(scope.row)"
                  icon="el-icon-operte-view"
                  class="editBtn"
                  style="margin-right: 10px"
                  >{{ button.name }}</el-button
                ><el-button
                  v-else-if="button.path === 'areaList-del'"
                  @click="del(scope.row)"
                  icon="el-icon-operte-view"
                  class="delBtn"
                  style="margin-right: 10px"
                  >{{ button.name }}</el-button
                >
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div
        style="
          text-align: right;
          margin-top: 15px;
          margin-right: 0px;
          height: 40px;
        "
        id="pages"
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="current"
          :page-sizes="[6, 16, 24, 32]"
          :page-size="size"
          layout="total, sizes, prev, pager, next"
          :total="totalCount"
          popper-class="adminHomeSelect"
        ></el-pagination
        ><!-- , jumper -->
      </div>
    </div>

    <el-dialog
      title="区域名称"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="637px"
      class="commonSimpleDialog"
    >
      <el-form
        :rules="rules"
        ref="commonForm"
        :model="commonForm"
        label-width="0px"
        @submit.native.prevent
      >
        <el-form-item prop="area_name" label="" maxlength="50">
          <el-input
            v-model="commonForm.area_name"
            placeholder="请输入区域名称"
            @keyup.enter.native="submit('commonForm')"
          ></el-input>
          <el-button
            type="primary"
            @click="submit('commonForm')"
            class="confirmBtn"
            >确 定</el-button
          ><el-button @click="dialogVisible = false" class="cancelBtn"
            >取 消</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { postJsonRequest, getRequest } from "../../../axios/api";

export default {
  name: "areaList",
  props: ["menuId"],
  data() {
    return {
      addPermission: null,
      buttonList: [],
      queryForm: {},
      commonForm: {},
      current: 1, //当前页数
      size: 18, //显示几条
      totalCount: 0, //总条数
      tableData: [],
      dialogVisible: false,
      addFlag: true,
      rules: {
        area_name: [
          { required: true, message: "区域名称不能为空", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.setGutterWidth();
    this.query();
    this.buttonList = [];
    this.addPermission = null;
    this.$emit("getMenuList", this.menuId, 1, 0, this.getButtonList);
  },
  methods: {
    getButtonList(buttonList) {
      let menuId = this.menuId;
      for (
        let i = 0, len = buttonList.length;
        i < len && this.buttonList.length === 0;
        i++
      ) {
        let button = buttonList[i];
        if (button) {
          let children = button.children;
          if (children) {
            children.forEach((child) => {
              this.getChildren(child);
            });
          }
        }
      }
    },
    getChildren(item) {
      let menuId = item.id;
      let children = item.children;
      if (this.menuId === menuId) {
        let otherButton = [];
        for (let i = 0, len = children.length; i < len; i++) {
          let child = children[i];
          if (child) {
            if (child.path === "areaList-add") {
              this.addPermission = child;
            } else if (child.path !== "areaList-view") {
              otherButton.push(child);
            }
          }
        }
        this.buttonList = otherButton;
      } else {
        if (children) {
          children.forEach((child) => {
            this.getChildren(child);
          });
        }
      }
    },
    callOnTabSelect() {
      this.$nextTick(function () {
        this.$refs.commonTable.doLayout();
      });
    },
    add() {
      this.$data.addFlag = true;
      this.$data.dialogVisible = true;
      this.$data.commonForm = {};
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid && this.$data.addFlag) {
          this.addArea();
        } else if (valid && !this.$data.addFlag) {
          this.editArea();
        } else {
          return false;
        }
      });
    },
    addArea() {
      let vue = this;
      postJsonRequest(
        "/basic-info-server/area/addArea.do",
        this.$data.commonForm
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            vue.$data.dialogVisible = false;
            vue.query();
            vue.$message({
              message: "提交成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (res.code != 401) {
            let msg = "请求失败";
            if (null != res) {
              msg = res.msg;
            }
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        })
        .catch((error) => {});
    },
    query() {
      let vue = this;
      getRequest(
        "/basic-info-server/area/getAreaList.do?pagesize=" +
          this.$data.size +
          "&currentpage=" +
          this.$data.current +
          this.getQueryParam()
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (null != res.data && !this.isEmptyArray(res.data.list)) {
              this.$data.totalCount = res.data.total;
              this.$data.tableData = res.data.list;
            } else {
              this.$data.totalCount = 0;
              this.$data.tableData = [];
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    //编辑
    edit(row) {
      this.doedit(row.area_id);
    },
    doedit(id) {
      let vue = this;
      this.postJsonRequest("/basic-info-server/area/getAreaById.do", {
        area_id: id,
      })
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (null != res.data) {
              this.$data.addFlag = false;
              this.$data.commonForm = res.data;
              this.$data.dialogVisible = true;
            } else {
              // let tips = "<i class='el-icon-warn-tip'></i>啊哦,请求数据不存在~";
              // this.$confirm(tips, "提示", {
              //   confirmButtonText: "好的",
              //   customClass: "customClass-style",
              //   iconClass: "",
              //   dangerouslyUseHTMLString: true,
              //   confirmButtonClass: "confirm-style",
              //   showCancelButton: false,
              // });
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    //编辑提交
    editArea() {
      let vue = this;
      postJsonRequest(
        "/basic-info-server/area/upateArea.do",
        this.$data.commonForm
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            vue.$data.dialogVisible = false;
            vue.query();
            vue.$message({
              message: "提交成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (res.code != 401) {
            let msg = "请求失败";
            if (null != res) {
              msg = res.msg;
            }
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        })
        .catch((error) => {});
    }, //删除
    del(row) {
      let tips =
        "<i class='el-icon-warn-tip'></i>将永久删除该条记录, 是否继续?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "customClass-style",
        iconClass: "",
        dangerouslyUseHTMLString: true,
        confirmButtonClass: "confirm-style",
        cancelButtonClass: "cancel-style",
      })
        .then(() => {
          this.doDel(row);
        })
        .catch(() => {});
    },
    doDel(row) {
      let vue = this;
      postJsonRequest("/basic-info-server/area/DelArea.do", row)
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            let totalPage = Math.ceil((this.totalCount - 1) / this.size);
            let currentPage =
              this.current > totalPage ? totalPage : this.current;
            this.current = currentPage < 1 ? 1 : currentPage;
            vue.query();
            vue.$message({
              message: "删除成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (res.code != 401) {
            let msg = "请求失败";
            if (null != res) {
              msg = res.msg;
            }
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        })
        .catch((error) => {});
    }, //分页函数
    handleSizeChange: function (val) {
      this.size = val;
      this.query();
    },
    handleCurrentChange: function (current) {
      this.current = current;
      this.query();
    },
  },
  watch: {
    dialogVisible: function (nval, oval) {
      this.defaultClearValidate();
    },
  },
};
</script>

<style>
.mainCommonListContainer {
  width: 100%;
  height: 100%;
}

.adminHomeContainer .el-tabs .el-tabs__content .commonSimpleDialog .el-dialog {
  margin-top: calc(25% - 155px) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/area/area.vue